// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outline_button_editor-layout {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #8F989D;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .outline_button_editor-layout:hover {\n    cursor: pointer; }\n  .outline_button_editor-layout .icon_button {\n    font-size: 1.2rem;\n    width: 1.2rem;\n    color: #8F989D;\n    fill: #8F989D; }\n", ""]);
// Exports
module.exports = exports;
